import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AccountService } from './account.service';
import * as fromActions from './slice';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class AccountEffects {
  loadAccounts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadAccounts),
      switchMap((_action) =>
        this.accountService.loadAccounts().pipe(
          // upsertAccounts is dispatched before loadAccountsSuccess such that any effects or selectors listening for
          // loadAccountsSuccess will see the accounts already available in the store.
          switchMap((accounts) => of(fromActions.upsertAccounts({ entities: accounts }), fromActions.loadAccountsSuccess())),
          catchError(() => of(fromActions.loadAccountsFailure()))
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly accountService: AccountService
  ) {}
}
